export default __webpack_public_path__ + "static/media/writing.864a9877.png";